module.exports = __webpack_public_path__ + "static/media/ncnews.5d5d1289.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ncnews.jpeg
// module id = 76
// module chunks = 0